import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { Feriado } from 'src/app/models/feriado';
import { CarregandoService } from 'src/app/services/carregando.service';
import { FeriadoService } from 'src/app/services/feriado.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';

@Component({
  selector: 'app-cadastrar-feriado',
  templateUrl: './cadastrar-feriado.component.html',
  styleUrls: ['./cadastrar-feriado.component.scss']
})
export class CadastrarFeriadoComponent implements OnInit {
  idFeriado: number = 0;
  feriado = new Feriado();
  editando = false;
  carregando = true;

  constructor(
    private feriadoService: FeriadoService,
    private route: ActivatedRoute,
    private notificacaoService: NotificacaoService,
    private router: Router,
    private carregandoService: CarregandoService,
    public dialog: MatDialog,
  ) { }

  ngOnInit() {
    if (this.route.snapshot.paramMap.get('id')) {
      this.idFeriado = Number(this.route.snapshot.paramMap.get('id'));
      this.editando = true;

      this.buscarFeriado();
    } else {
      this.feriado = new Feriado();
    }
  }

  buscarFeriado() {
    this.carregandoService.mostra('buscaFeriado');
    this.feriadoService.buscar(this.idFeriado).subscribe(data => {
      this.feriado = data;

      this.carregando = false;
      this.carregandoService.esconde('buscaFeriado');
    }, erro => {
      this.notificacaoService.erro(erro);
      this.carregando = false;
      this.carregandoService.esconde('buscaFeriado');
    });
  }

  salvar() {
    this.carregandoService.mostra('salvarFeriado');
    this.feriadoService.salvar(this.feriado).subscribe(data => {
      this.notificacaoService.sucesso('Feriado salvo com sucesso!');
      this.carregandoService.esconde('salvarFeriado');
      this.router.navigate(['/configuracoes/feriado']);
    }, (erro) => {
      this.notificacaoService.erro(erro);
      this.carregandoService.esconde('salvarFeriado');
    });
  }
}
